import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '../components/layout/Sidebar';
import { TopBar } from '../components/layout/TopBar';
import { Menu } from 'lucide-react';
import { Button } from '../components/ui/Button';
export const MainLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  // Handle responsive behavior
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth < 1024) {
        setSidebarOpen(false);
      } else {
        setSidebarOpen(true);
      }
    };
    // Set initial state
    checkScreenSize();
    // Add event listener
    window.addEventListener('resize', checkScreenSize);
    // Cleanup
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);
  return <div className="flex h-screen bg-bg-50 overflow-hidden" data-id="element-194">
      {/* Mobile sidebar backdrop */}
      {isMobile && sidebarOpen && <div className="fixed inset-0 bg-bg-900 bg-opacity-50 z-20 transition-opacity duration-200" onClick={() => setSidebarOpen(false)} aria-hidden="true" data-id="element-195" />}
      {/* Sidebar */}
      <div className={`${isMobile ? `fixed inset-y-0 left-0 z-30 transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}` : sidebarOpen ? 'block' : 'hidden'} transition-all duration-300 ease-in-out`} data-id="element-196">
        <Sidebar onClose={() => setSidebarOpen(false)} data-id="element-197" />
      </div>
      {/* Main content */}
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-198">
        <TopBar data-id="element-199">
          <Button variant="tertiary" className="mr-2 md:hidden" onClick={() => setSidebarOpen(true)} aria-label="Open menu" data-id="element-200">
            <Menu size={20} data-id="element-201" />
          </Button>
        </TopBar>
        <main className="flex-1 overflow-y-auto bg-bg-100 pt-2" data-id="element-202">
          <div className="container mx-auto px-4 max-w-7xl" data-id="element-203">
            <Outlet data-id="element-204" />
          </div>
        </main>
      </div>
    </div>;
};